import { computed, inject, Injectable, signal } from '@angular/core';
import { IAuthSession } from '@core/interfaces/entidades/auth-session.interface';
import { SucursalService } from './sucursal.service';
import { LocalStorageService } from './local-storage.service';
import { ILoginDTO } from '@core/interfaces/request-response/login.dto.interface';

@Injectable({
  providedIn: 'root',
})
export class AuthStateService {
  private sucursalState = inject(SucursalService);
  private localStorageService = inject(LocalStorageService);

  authReady = signal<boolean>(false);
  session = signal<IAuthSession | null>(null);
  accessToken = signal<string | null>(null);
  empresaId = computed(() => this.session()?.empresa_id ?? null);
  usuarioId = computed(() => this.session()?.id ?? null);
  nombreCompleto = computed(() => this.session()?.nombre_completo ?? null);
  email = computed(() => this.session()?.email ?? null);

  setSession(rs: ILoginDTO | null) {
    if (rs === null) {
      this.clearSession();
      return;
    }
    this.session.set(rs.payload);
    if (rs.access_token) {
      this.accessToken.set(rs.access_token);
    }
    this.sucursalState.sucursalRestringidaId.set(rs.payload.sucursal_id ?? null);
    this.authReady.set(true);
  }

  setAuthReady(ready: boolean) {
    this.authReady.set(ready);
  }

  setAccessToken(token: string | null) {
    this.accessToken.set(token);
  }

  clearSession() {
    this.authReady.set(false);
    this.session.set(null);
    this.accessToken.set(null);

    this.sucursalState.clear();
    this.localStorageService.clear();
  }
}
